import { initLoading, showHideLoading } from "../../components/loading/loading";
import { findItem, getQueryStringParams } from "../../utils/common-function";
export function browserParamsHandler(data) {
    let browserInputObject = getQueryStringParams(data);
    return browserInputObject;
}
/** this function to initialize loading control
 * @param  parent the div id for parent dom*
*/
export function loadingHandler(parent) {
    initLoading(parent);
}
/**@category web controls */
export function Loading(disabled) {
    showHideLoading(disabled);
}
export function findItemInList(array, column, id) {
    return findItem(array, column, id);
}
/**@category utilities */
export function browserDetection() {
    let userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
    }
    else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
    }
    else if (userAgent.match(/safari/i)) {
        browserName = "safari";
    }
    else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
    }
    else if (userAgent.match(/edg/i)) {
        browserName = "edge";
    }
    else {
        browserName = "none";
    }
    return browserName;
}
